import { useState } from 'react'
import { Avatar, Mentions, Space /*Upload*/ } from 'antd'
import { SendOutlined } from '@ant-design/icons'
import Button from 'modules/core/components/Button/Button'
import Typography from 'modules/core/components/Typography/Typography'
// import { useState } from 'react'
// import { PictureOutlined } from '@ant-design/icons'

import './CardEmpty.scss'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import login from 'modules/login'
import PropTypes from 'prop-types'

const CardEmpty = ({ onCommentCreate, usersList, loggedUser }) => {
  const { t } = useTranslation()
  const [usersIds, setUsersIds] = useState([])
  const [textValue, setTextValue] = useState('')
  // const [value, setValue] = useState(null)
  // const [fileList, setFileList] = useState([])

  const handleSelect = (id) => {
    id = parseInt(id)
    // Agregar el ID seleccionado al estado si no está ya presente
    setUsersIds((prevIds) => {
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      return prevIds
    })
  }

  const handleChange = (newValue) => {
    setTextValue(newValue)

    const validIds = usersList?.values
      .filter((user) => newValue.includes(`@${user.first_name}${user.last_name}`))
      .map((user) => user.id)

    setUsersIds(validIds)
  }

  return (
    <div className="card-empty-comment">
      <div>
        <Space direction="horizontal">
          <Avatar style={{ backgroundColor: '#0047ba' }} size="small">
            {`${loggedUser?.firstName[0]}`.toUpperCase()}
          </Avatar>
          <Mentions
            placeholder={t('WRITE_COMMENT_PLACEHOLDER')}
            rows={2}
            onClick={(e) => e.stopPropagation()}
            onSelect={(d) => handleSelect(d.key)}
            onChange={handleChange}
          >
            {usersList?.values
              .filter((el) => el.id !== loggedUser?.pkid)
              .map((user) => (
                <Mentions.Option key={user.id} value={`${user.first_name}${user.last_name}`}>
                  {user.first_name}
                  {user.last_name}
                </Mentions.Option>
              ))}
          </Mentions>
          <Button.Icon
            icon={<Typography.Icon level={2} icon={SendOutlined} />}
            title="enviar"
            disabled={!textValue}
            onClick={(e) => {
              e.stopPropagation()
              onCommentCreate(textValue, usersIds)
            }}
          />
        </Space>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

CardEmpty.propTypes = {
  onCommentCreate: PropTypes.func,
  usersList: PropTypes.shape({
    values: PropTypes.array,
  }),
  loggedUser: PropTypes.shape({
    firstName: PropTypes.string,
    pkid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
}

export default connect(mapStateToProps, null)(CardEmpty)
